import { useEffect, useRef, useState } from "react";
import { IBppFormSecondSectionInterface } from "../../../interfaces/forms/BPPForm/bpp-form-second-section.interface";
import { IBPPFormThirdSectionInterface } from "../../../interfaces/forms/BPPForm/bpp-form-third-section.interface";
import { IBppFormFourthSectionInterface } from "../../../interfaces/forms/BPPForm/bpp-form-fourth-section.interface";
import { IBppFormFifthSectionInterface } from "../../../interfaces/forms/BPPForm/bpp-form-fifth-section.interface";
import { IBppFormSixthSectionInterface } from "../../../interfaces/forms/BPPForm/bpp-form-sixth-section.interface";
import { IBppFormThirteenthSectionInterface } from "../../../interfaces/forms/BPPForm/bpp-form-thirteenth-section.interface";
import { IBppFormSeventhSectionInterface } from "../../../interfaces/forms/BPPForm/bpp-form-seventh-section.interface";
import { IBppFormEighthSectionInterface } from "../../../interfaces/forms/BPPForm/bpp-form-eighth-section.interface";
import { IBppFormNinthSectionInterface } from "../../../interfaces/forms/BPPForm/bpp-form-ninth-section.interface";
import { IBppFormTenthSectionInterface } from "../../../interfaces/forms/BPPForm/bpp-form-tenth-section.interface";
import { IBppFormEleventhSectionInterface } from "../../../interfaces/forms/BPPForm/bpp-form-eleventh-section.interface";
import { IBppFormTwelfthSectionInterface } from "../../../interfaces/forms/BPPForm/bpp-form-twelfth-section.interface";
import { drawDOM, exportPDF } from "@progress/kendo-drawing";
import shared from "../PDF-Shared-style.module.scss";
import classes from "./BPP-Form-PDF-style.module.scss";
import { IBppFormFifteenthSectionInterface } from "../../../interfaces/forms/BPPForm/bpp-form-fifteenth-section.interface";
import { IBppFormFourteenthSectionInterface } from "../../../interfaces/forms/BPPForm/bpp-form-fourteenth-section.interface";
import { settingsService } from "src/services/settings.service";
import { appendSupportingDocumentsToPdfHelper } from "src/context/SelectedForm/selected-form-context.helper";
import { useSelectedFormContext } from "src/context/SelectedForm/selected-form-context";
import { AxiosError } from "axios";
import { setLoading, temporaryError } from "src/context/shared/shared-context.helper";
import { GetCheckbox, GetFixedWidthCheckbox, GetYesNoCheckboxGroup } from "../PDFCheckbox";
import './FormPDFTemplate.css'
import { IBPPFormPersonalPropertySegmentsInterface } from "src/interfaces/forms/BPPForm/bpp-form-personal-property-segments.interface";
import { BppPdfAssetsTable } from "./BppPdfAssetsTable";
import { ScheduleETable1 } from "./Tables/ScheduleE/ScheduleETable1";
import { ScheduleETable2 } from "./Tables/ScheduleE/ScheduleETable2";
import { ScheduleA } from "./Tables/ScheduleA";
import { ScheduleB } from "./Tables/ScheduleB";
import { ScheduleC } from "./Tables/ScheduleC";
import { ScheduleD } from "./Tables/ScheduleD";
import { ScheduleF } from "./Tables/ScheduleF";
import { IFormFilesInterface } from "src/interfaces/forms/Shared/form-files.interface";
 import { useSharedContext } from "src/context/shared/shared-context";
interface IFormFields {
  formDataFieldsSecondSection?: IBppFormSecondSectionInterface;
  formDataFieldsThirdSection?: IBPPFormThirdSectionInterface;
  formDataFieldsFourthSection?: IBppFormFourthSectionInterface;
  formDataFieldsFifthSection?: IBppFormFifthSectionInterface;
  formDataFieldsSixthSection?: IBppFormSixthSectionInterface;
  formDataFieldsSeventhSection?: IBppFormSeventhSectionInterface;
  formDataFieldsEighthSection?: IBppFormEighthSectionInterface;
  formDataFieldsNinthSection?: IBppFormNinthSectionInterface;
  formDataFieldsTenthSection?: IBppFormTenthSectionInterface;
  formDataFieldsEleventhSection?: IBppFormEleventhSectionInterface;
  formDataFieldsTwelfthSection?: IBppFormTwelfthSectionInterface;
  formDataFieldsThirteenthSection?: IBppFormThirteenthSectionInterface;
  formDataFieldsFourteenthSection?: IBppFormFourteenthSectionInterface;
  formDataFieldsFifteenSection?: IBppFormFifteenthSectionInterface;
  supportingDocuments?: IFormFilesInterface[];
  accessCode: string;
  assets?: IBPPFormPersonalPropertySegmentsInterface[],
  getPdfBase64Url?: (url: string) => void;
}
 
const template = (context: any) => {
  if (context.pageNum === 1) {
    return '';
  }
  context.element.style.paddingTop = '16px';
  return `
    <div class="form-pdf-template">
      <div class="form-pdf-header">
        <div class="form-pdf-header-text">
          Business Personal Property Rendition of Taxable Property
        </div>
        <div class="form-pdf-header-text">
          Form 50-144
        </div>
      </div>
      <div class="form-pdf-footer-container">
        <div class="form-pdf-footer">
          <hr class="form-pdf-footer-hr"/>
          <div class="form-pdf-footer-text">
            For additional copies, visit: <b>comptroller.texas.gov/taxes/property-tax</b>
          </div>
          <div class="form-pdf-footer-text">
            Page ${context.pageNum}
          </div>
        </div>
      </div>
    </div>
  `
}
 
export default function BPPRenditionFormPDFView(props: IFormFields): JSX.Element {
  const {
    formDataFieldsSecondSection,
    formDataFieldsThirdSection,
    formDataFieldsFourthSection,
    formDataFieldsFifthSection,
    formDataFieldsSixthSection,
    formDataFieldsSeventhSection,
    formDataFieldsEighthSection,
    formDataFieldsNinthSection,
    formDataFieldsTenthSection,
    formDataFieldsEleventhSection,
    formDataFieldsTwelfthSection,
    formDataFieldsThirteenthSection,
    formDataFieldsFifteenSection,
    supportingDocuments = [],
    accessCode,
    getPdfBase64Url,
    assets,
  } = props;
  const { sharedState, sharedDispatch } = useSharedContext();
  const templateRef = useRef(null);
  const [templateBase64, setTemplateBase64] = useState("");
  const { selectedFormDispatch } = useSelectedFormContext();
  const settings = settingsService().settings;

  useEffect(() => {
    drawDOM(templateRef.current as any, {
      paperSize: "A4",
      keepTogether: '.keepTogether',
      template,
      margin: { bottom: '16px' },
      repeatHeaders: true,
    })
      .then((group) => {
        if (templateRef.current) {
          const myReference = templateRef.current as any;
          myReference.style.display = "none";
        }
        return exportPDF(group);
      })
      .then((dataUri) => {
        return appendSupportingDocumentsToPdfHelper(selectedFormDispatch, accessCode, dataUri, supportingDocuments)
        .then((dataUri) => {
          setTemplateBase64(dataUri);
          if (getPdfBase64Url) {
            getPdfBase64Url(dataUri);
          }
        })
        .catch((error: AxiosError) => {
                setLoading(selectedFormDispatch);
                temporaryError(selectedFormDispatch, error.response?.data)
            }
        );
      })

  }, []);
 const {
  BusinessAddressLine1,
  BusinessAddressCity,
  BusinessAddressState,
  BusinessAddressZip
} = formDataFieldsSecondSection|| {};
const formattedAddress = [
  BusinessAddressLine1,
  BusinessAddressCity,
  BusinessAddressState,
  BusinessAddressZip
]
  .filter(Boolean)
  .join(", ");
  return (
    <>
      {templateRef && templateBase64 && (
        <iframe
          style={{ width: "100%", height: "100%" }}
          src={templateBase64}
        />
      )}
      <div ref={templateRef} className={`${shared.FormContainer} ${shared.Form}`}>
        <div className={shared.PrintTogether}>
          <div className={`${shared.Row} ${shared.AlignCenter}`}>
            <div className={`${shared.Column10} ${shared.FormTitle}`}>
              Business Personal Property Rendition of Taxable Property
            </div>
            
          </div>

             <div className={shared.Row}>
                 <div style={{ marginTop: 20 }} className={`${shared.Column12} ${shared.Font10}`}>
  <p>I am requesting an extension of the filing deadline for my Business Personal Property rendition to <b>May 15</b></p>
                 </div>
             </div>
          <div className={shared.Row}>
            <div style={{ marginTop: 10 }}  className={`${shared.Column12} ${shared.Font10}`}>
                  <label><b>Account Number: </b></label>
             {formDataFieldsSecondSection?.AccountNumber}
            </div>
          </div>
           <div className={shared.Row}>
             <div style={{ marginTop: 10 }}  className={`${shared.Column12} ${shared.Font10}`}>
                {formDataFieldsSecondSection?.BusinessName}
             </div>
           </div>
    <div className={shared.Row}>
             <div style={{ marginTop: 10 }}  className={`${shared.Column12} ${shared.Font10}`}>
                {formDataFieldsSecondSection?.BusinessOwnerName}
                </div>
             </div>
  <div className={shared.Row}>
      <div style={{ marginTop: 10 }}  className={`${shared.Column12} ${shared.Font10}`}>
{formattedAddress}
      </div>
  </div>
  <div className={shared.Row}  style={{ marginTop: 10 }} >
            <div className={shared.Column8}>
              <div className={shared.Value}>
              {formDataFieldsFifteenSection?.Signature}
              </div>
              <div className={shared.ValueLabelBelow}>Signature</div>
            </div>
            <div className={shared.Column4}>
              <div className={shared.Value}>
                {formDataFieldsFifteenSection?.SignatureDate
                  ? new Date(
                      formDataFieldsFifteenSection?.SignatureDate
                    ).toDateString()
                  : formDataFieldsFifteenSection?.SignatureDate}
              </div>
              <div className={shared.ValueLabelBelow}>Date</div>
            </div>
          </div>
   </div>
   </div>
    </>
  );
}
